"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React, { useState } from "react"
import { map } from "lodash"
import styles from "./styles.module.scss"
import AccordionItem from "./shared/AccordionItem"
import Header from "../shared/Header"
import SectionContainer from "../shared/SectionContainer"
import { ACCORDION_ITEMS } from "./shared/constants"

function FAQSection() {
  const [expanded, setExpanded] = useState(null)

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }

  const renderHeader = () => {
    return <Header text="Frequently asked questions" />
  }

  const renderBody = () => {
    return (
      <div className={styles["body"]}>
        We are here to help! If you can’t find what you’re looking for or have ideas
        you’d like us to consider, please message our friendly team at
        support@zestlife.com. We are eager to collaborate!
      </div>
    )
  }

  const renderAccordion = () => {
    return (
      <div>
        {map(
          ACCORDION_ITEMS,
          ({ accordionSummaryTypography, accordionDetailsTypography }, index) => {
            return (
              <AccordionItem
                panel={`panel${index}`}
                accordionSummaryTypography={accordionSummaryTypography}
                accordionDetailsTypography={accordionDetailsTypography}
                handleChange={handleChange}
                expanded={expanded}
                key={`panel${index}`}
              />
            )
          },
        )}
      </div>
    )
  }

  return (
    <SectionContainer>
      {renderHeader()}
      {renderBody()}
      {renderAccordion()}
    </SectionContainer>
  )
}
export default FAQSection
